import React, { Component, createRef } from 'react';

// CSS
import './Meetings.scss';

// Helper
import { checkCookie } from '../../Helper/Cookies';
import { apiFetch } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { TabView, TabPanel } from 'primereact/tabview';

// Properties
const properties = require('../../properties.json');

function time(iso) {
    return iso ? new Date(iso).toLocaleTimeString('ar-EG', { hour: 'numeric', minute: '2-digit' }) : '—';
}

function dateTime(iso) {
    return iso ? new Date(iso).toLocaleString('ar-EG', { weekday: 'long', day: 'numeric', month: 'long', hour: 'numeric', minute: '2-digit' }) : '—';
}

// CSV times in Western digits (Excel sorts / filters them)
function csvTime(iso) {
    return iso ? new Date(iso).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '';
}

// CSV cells: quote everything, and neutralise leading = + - @ so a spreadsheet never runs a name as a formula
function cell(v) {
    let s = v === null || v === undefined ? '' : String(v);
    if (/^[=+\-@]/.test(s)) s = "'" + s;
    return '"' + s.replace(/"/g, '""') + '"';
}

// Who attended a meeting, for how long, and who didn't come (from the meeting server's join / leave events).
class MeetingAttendance extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = { report: null, error: null }

    componentDidMount() {
        document.title = properties.site_name + ' | تقرير الحضور';
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
            return;
        }
        this.load();
        this.timer = setInterval(() => { if (this.state.report && this.state.report.status === 'LIVE') this.load(); }, 30000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    load = () => {
        apiFetch(`/meetings/${this.props.match.params.id}/attendance`)
            .then(report => this.setState({ report, error: null }))
            .catch(e => this.setState({ error: e.message || String(e) }));
    }

    exportCsv = () => {
        const r = this.state.report;
        const lines = [['الحالة', 'الاسم', 'الكود', 'الموبايل', 'أول دخول', 'آخر خروج', 'الدقائق', 'النسبة %', 'مرات الدخول'].map(cell).join(',')];
        r.attended.forEach(a => lines.push(['حضر', a.name, a.code, a.mobile, csvTime(a.firstJoinedAt), a.present ? 'لسه موجود' : csvTime(a.lastLeftAt),
            a.minutes, a.percent, a.sessions].map(cell).join(',')));
        r.absent.forEach(a => lines.push(['غاب', a.name, a.code, a.mobile, '', '', 0, 0, 0].map(cell).join(',')));
        // BOM so Excel opens the Arabic correctly
        const blob = new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `attendance-${r.meetingId}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    }

    render() {
        const { report: r, error } = this.state;
        return (
            <>
                <Header pageName="تقرير الحضور" />
                <Toast ref={this.toast}></Toast>
                <div className="content meetings-page" dir="rtl">
                    <div className="container">
                        <div className="mt-top">
                            <Button label="رجوع للميتنجات" icon="pi pi-arrow-right" className="p-button-text" onClick={() => { window.location.href = '/meetings'; }} />
                            {r && <Button label="تنزيل Excel (CSV)" icon="pi pi-download" className="p-button-outlined" onClick={this.exportCsv} />}
                        </div>
                        {error && <p className="mt-error">{error}</p>}
                        {!r && !error && <p className="mt-hint">جاري التحميل...</p>}
                        {r && (
                            <>
                                <Card className="mt-card">
                                    <div className="mt-card-head">
                                        <h3>{r.title}</h3>
                                        {r.status === 'LIVE' ? <Tag value="مباشر الآن — بيتحدث كل 30 ثانية" severity="danger" /> : <Tag value="انتهى" severity="success" />}
                                    </div>
                                    <div className="mt-meta">
                                        <span><i className="pi pi-calendar" /> بدأ {dateTime(r.startedAt)}</span>
                                        {r.endedAt && <span><i className="pi pi-flag" /> انتهى {time(r.endedAt)}</span>}
                                        <span><i className="pi pi-clock" /> {r.meetingMinutes} دقيقة</span>
                                    </div>
                                    <div className="mt-stats">
                                        <div><strong>{r.attended.length}</strong><span>حضر</span></div>
                                        <div><strong>{r.absent.length}</strong><span>غاب</span></div>
                                        <div><strong>{r.eligible ? Math.round(r.attended.length * 100 / r.eligible) : 0}%</strong><span>نسبة الحضور من {r.eligible} طالب</span></div>
                                        <div><strong>{r.attended.length ? Math.round(r.attended.reduce((n, a) => n + a.minutes, 0) / r.attended.length) : 0}</strong><span>متوسط دقائق الحضور</span></div>
                                    </div>
                                    {!r.startedAt && <p className="mt-hint">الميتنج لسه ما بدأش.</p>}
                                </Card>
                                <TabView>
                                    <TabPanel header={`حضر (${r.attended.length})`}>
                                        <div className="mt-table-wrap">
                                            <table className="mt-table">
                                                <thead><tr><th>الاسم</th><th>الكود</th><th>الموبايل</th><th>أول دخول</th><th>آخر خروج</th><th>المدة</th><th>مرات الدخول</th></tr></thead>
                                                <tbody>
                                                    {r.attended.map(a => (
                                                        <tr key={a.studentProfileId}>
                                                            <td>{a.name}</td>
                                                            <td dir="ltr">{a.code || '—'}</td>
                                                            <td dir="ltr">{a.mobile || '—'}</td>
                                                            <td>{time(a.firstJoinedAt)}</td>
                                                            <td>{a.present ? <Tag value="موجود الآن" severity="success" /> : time(a.lastLeftAt)}</td>
                                                            <td>
                                                                <div className="mt-bar"><span style={{ width: `${a.percent}%` }} /></div>
                                                                {a.minutes} دقيقة ({a.percent}%)
                                                            </td>
                                                            <td>{a.sessions}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            {r.attended.length === 0 && <p className="mt-hint">محدش حضر لسه.</p>}
                                        </div>
                                    </TabPanel>
                                    <TabPanel header={`غاب (${r.absent.length})`}>
                                        <div className="mt-table-wrap">
                                            <table className="mt-table">
                                                <thead><tr><th>الاسم</th><th>الكود</th><th>الموبايل</th></tr></thead>
                                                <tbody>
                                                    {r.absent.map(a => (
                                                        <tr key={a.studentProfileId}><td>{a.name}</td><td dir="ltr">{a.code || '—'}</td><td dir="ltr">{a.mobile || '—'}</td></tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            {r.absent.length === 0 && <p className="mt-hint">كل الطلاب حضروا.</p>}
                                        </div>
                                    </TabPanel>
                                </TabView>
                            </>
                        )}
                    </div>
                </div>
            </>
        );
    }
}

export default MeetingAttendance;
